
import { 
  FileText,
  IdCard
} from "lucide-react";
import type { MenuItem } from "../types";

export const visaSection: MenuItem = {
  title: "التأشيرات",
  href: "#",
  icon: IdCard,
  color: "from-amber-500 to-amber-600",
  subItems: [
    {
      title: "أنواع التأشيرات",
      href: "/visa-types",
      icon: FileText,
      color: "from-amber-500 to-amber-600",
      permission: "أنواع التأشيرات",
    },
    {
      title: "التأشيرات",
      href: "/visas",
      icon: IdCard,
      color: "from-lime-500 to-lime-600",
      permission: "التأشيرات",
    }
  ]
};
